module.exports = __webpack_public_path__ + "img/3.87480a2f.jpg";